export default __webpack_public_path__ + "static/media/smc.ba6d17dc.svg";